document.addEventListener('DOMContentLoaded', () => {
  const body = document.body;
  const qs = (selector, root = document) => root.querySelector(selector);
  const qsa = (selector, root = document) => [...root.querySelectorAll(selector)];

  const safeStorage = {
    get(key) { try { return localStorage.getItem(key); } catch (_) { return null; } },
    set(key, value) { try { localStorage.setItem(key, value); } catch (_) {} }
  };

  const gate = qs('[data-age-gate]');
  if (gate && !safeStorage.get('wm_age_ok')) gate.hidden = false;
  qs('[data-age-yes]')?.addEventListener('click', () => {
    safeStorage.set('wm_age_ok', '1');
    gate.hidden = true;
  });

  const nav = qs('[data-menu]');
  const menuToggle = qs('[data-menu-toggle]');
  const closeMenu = () => {
    nav?.classList.remove('is-open');
    menuToggle?.setAttribute('aria-expanded', 'false');
  };
  menuToggle?.addEventListener('click', () => {
    nav?.classList.add('is-open');
    menuToggle.setAttribute('aria-expanded', 'true');
  });
  qs('[data-menu-close]')?.addEventListener('click', closeMenu);
  qsa('.main-nav a').forEach(link => link.addEventListener('click', closeMenu));

  const backdrop = qs('[data-drawer-backdrop]');
  const cartDrawer = qs('[data-cart-drawer]');
  const wishDrawer = qs('[data-wishlist-drawer]');
  const allDrawers = [cartDrawer, wishDrawer].filter(Boolean);
  function closeDrawers() {
    allDrawers.forEach(drawer => {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
    });
    if (backdrop) backdrop.hidden = true;
    body.classList.remove('drawer-open');
  }
  function openDrawer(drawer) {
    if (!drawer) return;
    closeDrawers();
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (backdrop) backdrop.hidden = false;
    body.classList.add('drawer-open');
    qs('button', drawer)?.focus();
  }
  qsa('[data-cart-toggle]').forEach(button => button.addEventListener('click', () => openDrawer(cartDrawer)));
  qsa('[data-wishlist-toggle]').forEach(button => button.addEventListener('click', () => openDrawer(wishDrawer)));
  qsa('[data-drawer-close]').forEach(button => button.addEventListener('click', closeDrawers));
  backdrop?.addEventListener('click', closeDrawers);
  document.addEventListener('keydown', event => { if (event.key === 'Escape') { closeDrawers(); closeMenu(); } });

  const wishlistKey = 'wm_wishlist_v1';
  let wishlist = [];
  try { wishlist = JSON.parse(safeStorage.get(wishlistKey) || '[]'); } catch (_) { wishlist = []; }
  if (!Array.isArray(wishlist)) wishlist = [];
  const saveWishlist = () => safeStorage.set(wishlistKey, JSON.stringify(wishlist.slice(0, 50)));
  const isSaved = url => wishlist.some(item => item.url === url);
  function syncWishButtons() {
    qsa('[data-wm-wish]').forEach(button => {
      const saved = isSaved(button.dataset.url);
      button.classList.toggle('is-saved', saved);
      button.setAttribute('aria-pressed', saved ? 'true' : 'false');
    });
    qsa('[data-wishlist-count]').forEach(el => { el.textContent = wishlist.length; });
    qsa('[data-wishlist-heading-count]').forEach(el => { el.textContent = `(${wishlist.length})`; });
  }
  function renderWishlist() {
    const container = qs('[data-wishlist-items]');
    if (!container) return;
    if (!wishlist.length) {
      container.innerHTML = '<div class="drawer-empty"><h3>Save your mood</h3><p>Tap the heart on any product to keep it here.</p></div>';
      syncWishButtons();
      return;
    }
    container.innerHTML = wishlist.map((item, index) => `
      <article class="wishlist-item">
        <a href="${escapeHtml(item.url)}">${item.image ? `<img src="${escapeHtml(item.image)}" alt="">` : ''}</a>
        <div><a href="${escapeHtml(item.url)}"><b>${escapeHtml(item.title)}</b></a><small>${escapeHtml(item.price || '')}</small></div>
        <button type="button" aria-label="Remove ${escapeHtml(item.title)}" data-wishlist-remove="${index}">×</button>
      </article>`).join('');
    qsa('[data-wishlist-remove]', container).forEach(button => button.addEventListener('click', () => {
      wishlist.splice(Number(button.dataset.wishlistRemove), 1);
      saveWishlist(); renderWishlist();
    }));
    syncWishButtons();
  }
  function escapeHtml(value = '') {
    return String(value).replace(/[&<>'"]/g, character => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[character]));
  }
  qsa('[data-wm-wish]').forEach(button => button.addEventListener('click', event => {
    event.preventDefault(); event.stopPropagation();
    const url = button.dataset.url || '#';
    const existing = wishlist.findIndex(item => item.url === url);
    if (existing >= 0) wishlist.splice(existing, 1);
    else wishlist.unshift({ title: button.dataset.title || 'Saved item', url, image: button.dataset.image || '', price: button.dataset.price || '' });
    saveWishlist(); renderWishlist();
  }));
  renderWishlist();

  qsa('[data-media-target]').forEach(button => button.addEventListener('click', () => {
    const id = button.dataset.mediaTarget;
    qsa('[data-product-media]').forEach(media => media.classList.toggle('is-active', media.id === id));
    qsa('[data-media-target]').forEach(thumb => thumb.classList.toggle('is-active', thumb === button));
  }));

  const variantSelect = qs('[data-variant-select]');
  variantSelect?.addEventListener('change', () => {
    const option = variantSelect.selectedOptions[0];
    const available = option?.dataset.available === 'true';
    const price = option?.dataset.price || '';
    const compare = option?.dataset.compare || '';
    const desktopPrice = qs('[data-product-price]');
    if (desktopPrice) {
      desktopPrice.innerHTML = '';
      const current = document.createElement('span'); current.textContent = price; desktopPrice.append(current);
      if (compare) { const old = document.createElement('s'); old.textContent = compare; desktopPrice.append(old); }
    }
    const mobilePrice = qs('[data-mobile-product-price]');
    if (mobilePrice) {
      mobilePrice.innerHTML = '';
      const current = document.createElement('b'); current.textContent = price; mobilePrice.append(current);
      if (compare) { const old = document.createElement('s'); old.textContent = compare; mobilePrice.append(old); }
    }
    qsa('[data-product-add]').forEach(button => {
      button.disabled = !available;
      button.textContent = available ? 'Add to Bag' : 'Sold out';
    });
  });

  const filterPanel = qs('[data-filter-panel]');
  qs('[data-filter-toggle]')?.addEventListener('click', () => filterPanel?.classList.add('is-open'));
  qs('[data-filter-close]')?.addEventListener('click', () => filterPanel?.classList.remove('is-open'));
});
